var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.files.length > 0 || _vm.drop_file,
          expression: "files.length > 0 || drop_file",
        },
      ],
      class:
        "card border-secondary shadow-none " +
        (_vm.drop_file ? "bg-hover-ligthgrey" : ""),
      staticStyle: { "min-height": "150px", border: "1px dotted" },
    },
    [
      _c(
        "div",
        { staticClass: "card-body position-relative" },
        [
          _c("h6", { staticClass: "text-center font-weight-light mb-4" }, [
            _c("span", { staticClass: "d-none d-lg-block" }, [
              _vm._v("\n                    Para anexar, "),
              _c(
                "button",
                {
                  staticClass: "btn btn-link p-0",
                  staticStyle: { "font-size": "inherit" },
                  on: {
                    click: function ($event) {
                      return _vm.chooseFile()
                    },
                  },
                },
                [_vm._v("selecione")]
              ),
              _vm._v(" ou arraste o arquivo até aqui!\n                "),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "d-lg-none" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-success btn-block",
                  on: {
                    click: function ($event) {
                      return _vm.chooseFile()
                    },
                  },
                },
                [_vm._v("Incluir arquivo")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "transition-group",
            { attrs: { name: "slide-fade" } },
            [
              _vm._l(_vm.files, function (file, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: file.active !== false || file.success !== true,
                        expression:
                          "file.active !== false || file.success !== true",
                      },
                    ],
                    key: file.id,
                    staticClass: "mt-2",
                    attrs: { id: file.id },
                  },
                  [
                    file.active === false && file.success === false
                      ? _c("i", {
                          staticClass: "fas fa-cloud text-warning mr-1",
                          attrs: { title: "Aguardando upload" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    file.active === true && file.success === false
                      ? _c("i", {
                          staticClass:
                            "fas fa-cloud-upload-alt text-color-pulse-primary mr-1",
                          attrs: { title: "Upload" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    file.active === false && file.success === true
                      ? _c("i", {
                          staticClass: "fas fa-cloud text-success mr-1",
                          attrs: { title: "Upload realizado com Sucesso!" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(file.name) +
                          "\n                        "
                      ),
                      (!_vm.$refs.upload || !_vm.$refs.upload.active) &&
                      file.success === false
                        ? _c("span", [
                            file.data.detalhes &&
                            file.data.detalhes !== null &&
                            file.data.detalhes !== ""
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "ml-2 text-muted",
                                    attrs: { title: "Anotações" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-sticky-note",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.edit_info
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-primary border-0 p-1 ml-2",
                                    attrs: { title: "Editar " + file.name },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.editFile(file, index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                editar\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            (!_vm.$refs.upload || !_vm.$refs.upload.active) &&
                            file.success === false
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-danger border-0 p-1 ml-2",
                                    attrs: { title: "Remover " + file.name },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.remove(file)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    remover\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.d_edit_info,
                      expression: "d_edit_info",
                    },
                  ],
                  key: _vm.id_file + "-edit_file",
                  staticClass:
                    "position-absolute shadow card p-3 w-file_edit mb-3",
                  style:
                    "top:" + _vm.top_edit_info + ";left:" + _vm.left_edit_info,
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-end position-relative",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-icon border-0 btn-close",
                          attrs: { type: "button", title: "Fechar" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.closeEditFile()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-times font-size-09" })]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { attrs: { for: _vm.id_file + "-edit_file_name" } },
                      [_vm._v("Nome do arquivo")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.nome_arquivo_,
                          expression: "nome_arquivo_",
                          modifiers: { lazy: true },
                        },
                      ],
                      staticClass: "form-control w-100 text-wrap",
                      attrs: {
                        type: "text",
                        id: _vm.id_file + "-edit_file_name",
                        name: _vm.id_file + "-edit_file_name",
                      },
                      domProps: { value: _vm.nome_arquivo_ },
                      on: {
                        change: function ($event) {
                          _vm.nome_arquivo_ = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { attrs: { for: _vm.id_file + "-edit_file_detalhes" } },
                      [_vm._v("Anotações adicionais")]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.info_adicionais_arquivo_,
                          expression: "info_adicionais_arquivo_",
                          modifiers: { lazy: true },
                        },
                      ],
                      staticClass: "form-control w-100",
                      attrs: {
                        id: _vm.id_file + "-edit_file_detalhes",
                        name: _vm.id_file + "-edit_file_detalhes",
                        rows: "4",
                      },
                      domProps: { value: _vm.info_adicionais_arquivo_ },
                      on: {
                        change: function ($event) {
                          _vm.info_adicionais_arquivo_ = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm.d_btn_submit
            ? _c("div", [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.files.length > 0 &&
                          _vm.$refs.upload &&
                          !_vm.$refs.upload.active &&
                          _vm.btn_upload,
                        expression:
                          "files.length > 0 && $refs.upload && !$refs.upload.active && btn_upload",
                      },
                    ],
                    staticClass: "btn btn-primary btn-sm btn-block mt-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.$refs.upload.active = true
                        _vm.closeEditFile()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-cloud-upload-alt font-size-1 mr-1",
                      attrs: { title: "Upload" },
                    }),
                    _vm._v(" Upload\n                "),
                  ]
                ),
                _vm._v(" "),
                _vm.$refs.upload && _vm.$refs.upload.active
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-color-pulse-primary text-center font-size-1 font-weight-light pt-2",
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fas fa-cloud-upload-alt font-size-1 mr-1",
                        }),
                        _vm._v(" Enviando..."),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.$refs.upload && _vm.$refs.upload.active,
                        expression: "$refs.upload && $refs.upload.active",
                      },
                    ],
                    staticClass: "btn btn-danger btn-sm btn-block mt-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.$refs.upload.active = false
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-cloud mr-1" }),
                    _vm._v(" Stop upload\n                "),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("file-upload", {
        ref: "upload",
        attrs: {
          "input-id": _vm.id_file,
          name: _vm.name_file,
          maximum: _vm.maximum_files,
          multiple: true,
          "post-action": _vm.request.post,
          data: _vm.dados,
          headers: { "X-Token-CSRF": _vm.dados._token },
          drop: _vm.drop_file,
        },
        on: {
          input: _vm.updateFiles,
          "input-file": _vm.inputFile,
          "input-filter": _vm.inputFilter,
        },
      }),
      _vm._v(" "),
      _c("div", { attrs: { hidden: "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }